module.exports = __webpack_public_path__ + "static/img/instagram.96d33ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram.png
// module id = Thay
// module chunks = 2